import { Request } from '@/classes/Request'
import type { AthleticsMessage, AthleticsMessagePage } from '@/types/enrollments'
import {
  normalizeAthleticsAuthor,
  normalizeAthleticsConversation
} from '@/modules/api/get/athleticsMessagesInbox'

export const ATHLETICS_MESSAGE_PAGE_SIZE = 50

export const normalizeAthleticsMessage = (raw: any): AthleticsMessage => ({
  id: String(raw?.id ?? ''),
  conversationId: String(raw?.conversation_id ?? ''),
  author: normalizeAthleticsAuthor(raw?.author),
  body: String(raw?.body ?? ''),
  quotedAnnouncementId: raw?.quoted_announcement?.id ?? raw?.quoted_announcement_id ?? null,
  quotedAnnouncementSubject: raw?.quoted_announcement?.subject ?? null,
  deleted: raw?.deleted === true || Boolean(raw?.deleted_at),
  canDelete: raw?.can_delete === true,
  createdAt: String(raw?.created_at ?? '')
})

// GET /ajax/athletics/conversations/{id}/messages?before&limit (DTA-799
// round 11): one page, oldest → newest within the page. Reading marks the
// conversation read for this family user.
export const athleticsConversationMessages = async (
  conversationId: string,
  before: string | null = null,
  limit = ATHLETICS_MESSAGE_PAGE_SIZE
): Promise<AthleticsMessagePage> => {
  const params: Record<string, any> = { limit }
  if (before) params.before = before
  const response = await new Request(undefined, 'json', { redirectOnForbidden: false }).get(
    '/ajax/athletics/conversations/' + encodeURIComponent(conversationId) + '/messages',
    params
  )
  const data = response.data ?? {}
  const messages = (data.messages ?? []).map(normalizeAthleticsMessage)
  return {
    conversation: data.conversation ? normalizeAthleticsConversation(data.conversation) : null,
    messages,
    hasMore: data.has_more ?? messages.length >= limit,
    nextBefore: data.next_before ?? messages[0]?.createdAt ?? null
  }
}
